import React from "react";
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import toast from "react-hot-toast";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import Loading from "../components/Loading.jsx";

import { login } from "../services/authService.js"; // Import the login function

const Login = () => {
  const { persist, setPersist, setAuth } = useAuth();

  const [logemail, setEmail] = useState("");
  const [logpassword, setPassword] = useState("");
  const [pastype, setType] = useState("password");

  const navigate = useNavigate();
  const location = useLocation();
  const from = location?.state?.from?.pathname || "/";

  const [loader, setloader] = useState(false);

  const togglePersist = () => {
    setPersist((prev) => !prev);
    localStorage.setItem("persist", !persist);
  };

  const handleToggle = () => {
    if (pastype === "password") {
      setType("text");
    } else {
      setType("password");
    }
  };

  const handleSubmit = async (e) => {
    setloader(true);
    e.preventDefault();
    try {
      const response = await login(logemail, logpassword); // Use the login service

      if (response.data.message === "Login Successful") {
        togglePersist(); //
        //console.log(response.data);
        toast.success("Login Successful!");
        const accessToken = response?.data?.accessToken; //accessToken JWT from server stored into auth context
        const role = response?.data?.role;
        const authpassword = response?.data?.result?.password;
        const donor_id = response?.data?.result?.donor_id;

        setAuth({
          id: response?.data?.result?._id,
          donor_id: donor_id,
          email: logemail,
          pass: authpassword,
          role: role,
          token: accessToken,
        }); //saved in global auth context

        navigate(from, { replace: true });
      } else {
        //console.log(response);
        setloader(false);
        toast.error(response?.data?.message);
      }
    } catch (err) {
      //?
      setloader(false);
      console.log(err);
      if (!err?.reponse) {
        toast.error("Login Failed");
      } else if (err.response?.status === 400) {
        toast.error("Missing username or password");
      } else if (err.response?.status === 401) {
        toast.error("Unauthorized");
      } else {
        toast.error("Login Failed");
      }
    }
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center px-4 mx-auto h-screen font-pop">
        {loader ? (
          <div className="flex flex-col">
            <Loading />
          </div>
        ) : (
          <div className="w-full bg-red-100 rounded-lg shadow sm:max-w-md">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-900 md:text-3xl">
                Welcome to <span className="text-red-600">BloodDoNation</span>
              </h1>

              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                Login
              </h1>

              <form
                onSubmit={handleSubmit}
                className="space-y-4 md:space-y-6"
                autoComplete="off"
              >
                <div>
                  <label htmlFor="username" className="mr-2 font-bold">
                    Email :
                  </label>
                  <input
                    type="email"
                    className="input-red"
                    required
                    id="email"
                    name="email"
                    value={logemail}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="password" className="mr-2 font-bold">
                    Password :
                  </label>
                  <div className="flex relative">
                    <input
                      type={pastype}
                      className="input-red"
                      required
                      id="password"
                      name="password"
                      value={logpassword}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className="absolute right-0 p-3"
                      onClick={handleToggle}
                    >
                      {pastype === "password" ? (
                        <FiEyeOff size={22} />
                      ) : (
                        <FiEye size={22} />
                      )}
                    </span>
                  </div>
                </div>
                <button
                  type="submit"
                  className="w-full text-white bg-red-600 hover:bg-red-200 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-2.5 py-2.5 text-center"
                >
                  Login
                </button>
              </form>

              <p className="text-sm font-light text-gray-500 flex-col space-y-4">
                <div>
                  Don't have an account yet?{" "}
                  <Link
                    to="/register"
                    className="font-bold text-lg text-red-600 underline"
                  >
                    SignUp
                  </Link>
                </div>
                {/*<Link
                  to="/forgotpassword"
                  className="font-bold text-lg text-red-400 underline"
                >
                  Forgot Password?
                </Link>*/}
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Login;
